module.exports = __webpack_public_path__ + "media/images/runner-red-e8a14b41498cd90aa2b18f34e7ebc207.jpg";